module.exports = __webpack_public_path__ + "img/tpc-11.779f039b.jpg";